module.exports = {"content":{},"productInfo":{"code":"{969232A2-5728-4BC2-88EE-0202C2AD09C0}","name":"ドイツ語　初中級","serialHead":"PPNRA","courseResourceIDs":[{"levelNo":1,"resourceID":"4ef2b1e0a456ce754ddb38c3682ee0709affb723"},{"levelNo":2,"resourceID":"f0cb81af6ec4ffd201ec9323de43369af60bc390"},{"levelNo":3,"resourceID":"9d6484cfd029fbe000376f21a0fcfecddd4a6690"},{"levelNo":4,"resourceID":"1cbad62487dfd1e17324e5842fd60e4f9f4503df"},{"levelNo":5,"resourceID":"265fdfda314e2049deb39ddc15547643bda22413"}],"language":"de-DE","challengeCount":33706},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1